import React, { useState, useEffect } from 'react';
import { Layout, Row, Col, Card, Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import trainersData from '../data/trainers.json'; // Importa il file JSON

const { Content } = Layout;

const PersonalTrainersPage = () => {
    const [trainers, setTrainers] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        const filteredTrainers = trainersData.filter(trainer => trainer.id !== "99");
        setTrainers(filteredTrainers);
    }, []);

    const handleViewTrainer = (trainerId) => {
        navigate(`/trainer/${trainerId}`);
    };

    const cardStyle = {
        borderRadius: '8px', // Bordo arrotondato della card
        overflow: 'hidden' // Nasconde le parti in eccesso dell’immagine
    };

    const imgContainerStyle = {
        width: '100%',
        height: '250px', // Imposta un'altezza fissa per l’immagine
        backgroundSize: 'contain', // Fa entrare l’immagine nel contenitore senza ritagliarla
        backgroundPosition: 'center', // Centra l’immagine
        backgroundRepeat: 'no-repeat' // Evita che l’immagine si ripeta
    };

    return (
        <Layout style={{ minHeight: '100vh' }}>
            <Content style={{ maxWidth: '1000px', margin: '0 auto', padding: '20px' }}>
            <div className="trainer-title">
                    I NOSTRI PERSONAL TRAINER
                </div>
                <Row gutter={[16, 16]}>
                    {trainers.map((trainer) => (
                        <Col key={trainer.id} xs={24}>
                            <Card
                                hoverable
                                style={cardStyle}
                                cover={
                                    <div 
                                        style={{
                                            ...imgContainerStyle, 
                                            backgroundImage: `url(${trainer.profileImage || '/images/trainer/default.jpg'})`
                                        }}
                                    />
                                }
                            >
                                <h3>{trainer.name}</h3>
                                <Button
                                    type="primary"
                                    onClick={() => handleViewTrainer(trainer.id)}
                                >
                                    Visualizza Dettagli
                                </Button>
                            </Card>
                        </Col>
                    ))}
                </Row>
            </Content>
        </Layout>
    );
};

export default PersonalTrainersPage;
